import React, {Component} from "react";
import PropTypes from "prop-types";
import {default as ReportPlaceholderInternal} from "@mnjsplatform/components/lib/common/Reports/ReportPlaceholder"
import Instruction from "./Instruction";
import reactToText from "react-to-text";
import i18next from "i18next";
import {connect} from "react-redux";
import {CommandContext, GlobalDebugMode} from "@mnjsplatform/data";

class ReportPlaceholder extends Component {
    static contextType = CommandContext;

    constructor(props) {
        super(props);
        this.state = {
            settings: null
        }
    }

    componentDidMount() {
        this.initialize()
    }

    initialize = async () => {
        /*Ключ:
            WorkSiteId – идентификатор РМ
            CommandItemId – идентификатор команды в РМ
            PlaceholderId – идентификатор фрейма в команде
            PlaceholderName – наименование фрейма*/
        const menuItem = this.props.menuId ? this.props.menuItems.find(mi => mi.MenuID === this.props.menuId)
            : this.props.menuItems.find(mi => mi.AppCommand && mi.AppCommand.Param1 === this.context.key);
        this.command = menuItem && menuItem.AppCommand;
        this.placeholderId = (this.props.commandInstruction ? "COMMAND_HELP" : "") || this.props.placeholderId || this.props.reportKey;
        const cleanTitle = reactToText(this.props.title);
        let title = (this.props.commandInstruction ? i18next.t("Command_Instruction") : "") || this.props.staticTitle || cleanTitle || this.props.title || this.props.reportKey;
        if (this.props.getTitle) {
            title = this.props.getTitle();
        }

        this.key = {
            WorkSiteId: this.context.workplaceId,
            CommandItemId: this.command.ID,
            PlaceholderId: this.placeholderId,
            PlaceholderName: title
        };
        await this.props.dispatch(this.props.dataItem.reset());
        await this.props.dispatch(this.props.dataItem.execute(this.key));
        this.setState({settings: this.props.dataItem.getRow(0)})
    }

    render() {
        if (!this.state.settings) {
            return null;
        }
        if (this.state.settings["IsPlaceholderVisible"] !== 1) {
            return null;
        }
        const instruction = this.props.showInstruction && this.command &&
            <Instruction instructionId={this.props.instructionId} {...this.state.settings}/>;
        return (this.props.commandInstruction
                ? instruction
                : <div id={this.placeholderId} className={this.props.className}>
                    {GlobalDebugMode && JSON.stringify(this.key)}
                    {instruction}
                    <ReportPlaceholderInternal {...this.props}>
                    {this.props.children}
                </ReportPlaceholderInternal>
                </div>
        );
    }
}

ReportPlaceholder.propTypes = {
    dispatch: PropTypes.func.isRequired,
    reportId: PropTypes.string.isRequired,
    reportKey: PropTypes.string,
    params: PropTypes.object,
    reportParamsItem: PropTypes.object,
    showLabelOnLoading: PropTypes.bool,
    title: PropTypes.any,
    placeholderId: PropTypes.string,
    getTitle: PropTypes.func,
    showInstruction: PropTypes.bool,
    commandInstruction: PropTypes.bool,
    staticTitle: PropTypes.string,
    instructionId: PropTypes.string,
    menuId: PropTypes.string
};

ReportPlaceholder.defaultProps = {
    reportKey: "defaultReport",
    showLabelOnLoading: true,
    showInstruction: true,
    commandInstruction: false
};

function mapStateToProps(state, ownProps) {
    return {
        menuItems: state.appState.appParams.menu.Items,
        dataItem: state.instructionState.PersOffHelp_GetHelpForPO
    }
}

export default connect(mapStateToProps)(ReportPlaceholder);